// src/utils/watermark.js (完善版，支持多行、斜体、防篡改)

const watermarkId = 'system-global-watermark';
let observer = null;

// 简单的 Canvas 文本换行工具
const wrapText = (ctx, textArr, x, y, lineHeight) => {
    textArr.forEach((text, index) => {
        ctx.fillText(text, x, y + index * lineHeight);
    });
};

// 核心绘制逻辑：接收文本数组
const createWatermark = (textArr) => {
    // 1. 清理旧节点（防重复执行）
    const oldDiv = document.getElementById(watermarkId);
    if (oldDiv) {
        document.body.removeChild(oldDiv);
    }

    // 2. 使用 Canvas 生成水印背景图片
    const canvas = document.createElement('canvas');
    // 设置水印块的尺寸（影响密度），可以适当调大以容纳两行
    canvas.width = 400;
    canvas.height = 300;

    const ctx = canvas.getContext('2d');
    ctx.rotate((-20 * Math.PI) / 180); // 倾斜角度，同图二

    // 【核心修改】：设置斜体、字体、颜色及透明度，调淡一点以不影响主界面
    ctx.font = 'italic 16px PingFang SC, sans-serif';
    ctx.fillStyle = 'rgba(255, 0, 0, 0.1)';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'Middle';

    // 【核心修改】：绘制多行文本
    const lineHeight = 20; // 行高
    const startX = 20;
    const startY = 120;
    wrapText(ctx, textArr, startX, startY, lineHeight);

    // 3. 创建全屏覆盖的 DOM 节点
    const div = document.createElement('div');
    div.id = watermarkId;
    // 关键 CSS：pointer-events 保证事件穿透
    div.style.cssText = `
    pointer-events: none !important;
    top: 0px !important;
    left: 0px !important;
    position: fixed !important;
    z-index: 999999 !important;
    width: 100vw !important;
    height: 100vh !important;
    background: url(${canvas.toDataURL('image/png')}) left top repeat !important;
    opacity: 1 !important;
    display: block !important;
    visibility: visible !important;
  `;
    document.body.appendChild(div);

    return div;
};

// 暴露设置水印方法，接收文本数组 ['第一行文本', '第二行文本']
export const setWatermark = (textArr = ['系统内部水印', '']) => {
    createWatermark(textArr);

    // 4. MutationObserver 防篡改逻辑
    if (observer) {
        observer.disconnect(); // 断开旧观察者
    }

    // 监听 DOM 变化
    observer = new MutationObserver((mutations) => {
        const wmNode = document.getElementById(watermarkId);

        // 如果节点被删除，或者关键样式被篡改（如隐藏透明度），则重绘
        if (
            !wmNode ||
            wmNode.style.display === 'none' ||
            wmNode.style.opacity === '0' ||
            wmNode.style.visibility === 'hidden'
        ) {
            // 必须先断开观察，否则内部重绘会再次触发循环
            observer.disconnect();
            // 使用相同的文本数组重绘
            setWatermark(textArr);
        }
    });

    // 配置观察器：监听 body 子节点的增减，以及水印节点自身的属性变化
    observer.observe(document.body, { childList: true, subtree: true });
    const wmNode = document.getElementById(watermarkId);
    if (wmNode) {
        observer.observe(wmNode, { attributes: true });
    }
};

// 暴露移除水印方法（在用户登出或组件销毁时调用）
export const removeWatermark = () => {
    if (observer) {
        observer.disconnect();
        observer = null;
    }
    const div = document.getElementById(watermarkId);
    if (div) {
        document.body.removeChild(div);
    }
};
